import { Component, OnInit } from '@angular/core';
import { MDBModalRef } from 'angular-bootstrap-md';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss']
})
export class ErrorDialogComponent implements OnInit {
  action = new Subject();
  message: string;
  data: any;
  constructor(public modalRef: MDBModalRef) { }

  ngOnInit() {
  }
  close() {
    this.action.next('OK');
  }

}
